import { render } from "./AllReportTemplates.vue?vue&type=template&id=16c7d80a"
import script from "./AllReportTemplates.vue?vue&type=script&lang=js"
export * from "./AllReportTemplates.vue?vue&type=script&lang=js"

import "./AllReportTemplates.vue?vue&type=style&index=0&id=16c7d80a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__